import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import history from 'browserHistory'
import { selectors as ConfigSelectors } from 'data/config'
import providesIntegrationDetails from 'components/Integrations/dataSync/providesIntegrationDetails'
import { Button, Text } from 'components/base'
import RoutesHelper from 'helpers/RoutesHelper'
import ActivitySettingFromIntegration from './ActivitySettingFromIntegration'
import { SendActivityToIntegrationSection } from './utils'
import classnames from 'classnames'

class ActivitySetting extends React.Component {
  static propTypes = {
    integrationDetails: PropTypes.object,
    channelId: PropTypes.string.isRequired,
    integrationDetailsLoaded: PropTypes.bool.isRequired,
    clientId: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
  }

  state = {
    forceReinstallMessage: false,
  }

  handleNeedsReinstall = () => {
    this.setState({
      forceReinstallMessage: true,
    })
  }

  render() {
    const {
      integrationDetailsLoaded,
      integrationDetails,
      clientId,
      closeModal,
    } = this.props
    const { forceReinstallMessage } = this.state

    // todo: Make this generic when needed :)
    // integrationDetails are not loaded here so name isn't available.
    // We'll change this when we allow several integrations here.
    const applicationName =
      (integrationDetails && integrationDetails.name) || 'Slack'

    const needsIntegrationToBeInstalled =
      forceReinstallMessage ||
      !integrationDetails ||
      !integrationDetails.isInstalled ||
      !integrationDetails.integration.hasIntegrationActivitySupport
    const needsIntegrationWithActivityFeature =
      forceReinstallMessage ||
      (integrationDetails &&
        integrationDetails.isInstalled &&
        !integrationDetails.integration.hasIntegrationActivitySupport)

    const installIncentive = needsIntegrationWithActivityFeature
      ? `Reinstall ${applicationName} integration`
      : `Install ${applicationName} integration`

    if (!integrationDetailsLoaded) {
      return (
        <SendActivityToIntegrationSection applicationName={applicationName}>
          <Text.Detail>Loading...</Text.Detail>
        </SendActivityToIntegrationSection>
      )
    }

    if (needsIntegrationToBeInstalled) {
      return (
        <SendActivityToIntegrationSection applicationName={applicationName}>
          <Button.Primary
            className={classnames('pointer', {
              'margin-bottom-normal': needsIntegrationWithActivityFeature,
            })}
            onClick={() => {
              history.push(
                RoutesHelper.settingsIntegrationApplicationDetails({
                  applicationId: clientId,
                })
              )
              closeModal()
            }}
          >
            {installIncentive}
          </Button.Primary>
          {needsIntegrationWithActivityFeature && (
            <Text.SmallDetail>
              You need to reinstall this integration in order to enjoy this
              feature.
            </Text.SmallDetail>
          )}
        </SendActivityToIntegrationSection>
      )
    }

    return (
      <ActivitySettingFromIntegration
        channelId={this.props.channelId}
        applicationName={applicationName}
        integration={integrationDetails.integration}
        onNeedsReinstall={this.handleNeedsReinstall}
      />
    )
  }
}

export default compose(
  connect(state => {
    return {
      clientId: ConfigSelectors.getSlackAppSliteClientId(state),
    }
  }),
  providesIntegrationDetails()
)(ActivitySetting)
